import { createSlice } from "@reduxjs/toolkit";
import { GadgetInstallationStatusOnAllDevices } from "../../../helper/cloudcore/response/models/body";

export interface InstallOnAllDeviceSliceState {
    status: {
      [gadgetId: string]: GadgetInstallationStatusOnAllDevices
    }
}

const initialState: InstallOnAllDeviceSliceState = {
    status: {}
};

export const installOnAllDeviceSliceState = createSlice({
  name: "installOnAllDeviceSliceState",
  initialState,
  reducers: {
    reset: (state, action) => {
      const currentStatus = state.status;
      Object.keys(currentStatus).forEach((gadgetId, index) => {
        const currentGadgetData = currentStatus[gadgetId];
        const remainingDevices = currentGadgetData.remainingDevices;
        const newData: Record<number, GadgetInstallationStatusOnAllDevices> = {};
        newData[parseInt(gadgetId)] = {
            remainingDevices: [],
            successfullGadgetInstallationNo: 0,
            failedGadgetInstallationNo: remainingDevices ? remainingDevices.length : 0
        };
        state.status = {
          ...state.status,
          ...newData
        };
      });
    },
    resetByDeviceId: (state, action) => {
      const { deviceId } = action.payload;
      const currentStatus = state.status;
      Object.keys(currentStatus).forEach((gadgetId, index) => {
        const currentGadgetData = currentStatus[gadgetId];
        const currentRemainingDevices = currentGadgetData.remainingDevices;
        if(currentGadgetData && currentGadgetData.remainingDevices) {
          const newData: Record<number, GadgetInstallationStatusOnAllDevices> = {};
          newData[parseInt(gadgetId)] = {
              remainingDevices: currentRemainingDevices.filter(item => item !== deviceId),
              successfullGadgetInstallationNo: currentGadgetData.successfullGadgetInstallationNo,
              failedGadgetInstallationNo: currentGadgetData.failedGadgetInstallationNo
          };
          state.status = {
            ...state.status,
            ...newData
          };
        }
      });
    },
    initialize: (state, action) => {
      const {gadgetId, remainingDevices} = action.payload;
      const newData: Record<number, GadgetInstallationStatusOnAllDevices> = {};
      newData[gadgetId] = {
          remainingDevices: remainingDevices,
          successfullGadgetInstallationNo: 0,
          failedGadgetInstallationNo: 0
      };

      state.status = {
        ...state.status,
        ...newData
      };
    },
    updateForAllDevice: (state, action) => {
        const {gadgetId, deviceId, isSuccess} = action.payload;
        const currentData = state.status[gadgetId];
        const currentRemainingDevices = currentData.remainingDevices;
        if(currentRemainingDevices && currentRemainingDevices.includes(deviceId)) {
          const newData: Record<number, GadgetInstallationStatusOnAllDevices> = {};
          newData[gadgetId] = {
              remainingDevices: currentRemainingDevices.filter(it => it !== deviceId),
              successfullGadgetInstallationNo: isSuccess ? ++currentData.successfullGadgetInstallationNo : currentData.successfullGadgetInstallationNo,
              failedGadgetInstallationNo: !isSuccess ? ++currentData.failedGadgetInstallationNo : currentData.failedGadgetInstallationNo
          };
  
          state.status = {
            ...state.status,
            ...newData
          };
        }
    }
  },
});

export const { initialize, updateForAllDevice, reset, resetByDeviceId } = installOnAllDeviceSliceState.actions;
export default installOnAllDeviceSliceState.reducer;
